import EmblaCarousel from "@crescentParts/Components/EmblaCarousel";
import TrainingFiltersAccordionSection, {
    FacetModel,
} from "@crescentParts/Components/Training/TrainingFiltersAccordionSection";
import setFilters from "@crescentParts/Handlers/Custom/OnlineManufacturerTrainingHandler";
import { CustomOnlineManufacturerTrainingState } from "@crescentParts/Store/OnlineManufacturerTraining/OnlineManufacturerTrainingsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import isEmpty from "lodash/isEmpty";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const mapDispatchToProps = {
    setFilters,
};

const mapStateToProps = (state: CustomOnlineManufacturerTrainingState) => {
    const { typeFilters, appliedFilters, selectedFilterNamesArr, filteredTrainings } =
        state.customOnlineManufacturerTraining;
    return {
        location: getLocation(state),
        typeFilters,
        appliedFilters,
        selectedFilterNamesArr,
        filteredTrainings,
    };
};
export interface NewsListViewStyles {
    container?: InjectableCss;
    card?: InjectableCss;
    trainingType?: TypographyPresentationProps;
    title?: TypographyPresentationProps;
    description?: TypographyPresentationProps;
    buttonWrapper?: InjectableCss;
    button?: ButtonPresentationProps;
    cardsContainer?: InjectableCss;
    trainingCardImg?: InjectableCss;
    trainingCardContent?: InjectableCss;
    featuredContainer?: InjectableCss;
    featuredTrainingsWrapper?: InjectableCss;
    featuredTitleSection?: InjectableCss;
    featuredCardContent?: InjectableCss;
    featuredCardImg?: InjectableCss;
    featuredItem?: InjectableCss;
    learnMoreLink?: LinkPresentationProps;
    trainingsGridContainer?: GridContainerProps;
    trainingTitleSection?: GridItemProps;
    filtersGridItem?: GridItemProps;
    cardsGridItem?: GridItemProps;
    filterHeadingWrapper?: InjectableCss;
    filterSectionHeading?: TypographyPresentationProps;
    filterSectionsWrapper?: InjectableCss;
    featuredTrainingDate?: TypographyPresentationProps;
    noResultGridItem?: GridItemProps;
}

export const newsListViewStyles: NewsListViewStyles = {
    container: {
        css: css`
            margin-top: -40px;
        `,
    },

    trainingTitleSection: {
        width: 12,
        css: css`
            padding: 0 0 20px 0;
        `,
    },

    cardsGridItem: {
        width: [12, 12, 8, 8, 9],
        css: css`
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            row-gap: 20px;
            column-gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: repeat(1, 1fr);
                            padding-left: 0;
                            padding-right: 0;
                        `,
                        null,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                            padding-top: 0;
                            padding-right: 0;
                            padding-left: 10.5px;
                        `,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                        `,
                        css`
                            grid-template-columns: repeat(3, 1fr);
                        `,
                    ],
                    "min",
                )}
        `,
    },
    trainingCardImg: {
        css: css`
            max-height: 160px;
            height: 160px;
            width: 100%;
            img {
                height: 100%;
            }
        `,
    },
    card: {
        css: css`
            border-radius: 8px;
            height: 100%;
            background: ${getColor("secondary")};
            overflow: hidden;
            display: flex;
            flex-direction: column;
        `,
    },
    trainingType: {
        variant: "headerTertiary",
        color: "#636363",
        css: css`
            text-transform: capitalize;
            margin-bottom: 5px;
        `,
    },
    title: {
        variant: "h5",
        color: "text.accent",
        css: css`
            flex-grow: 1;
        `,
    },
    description: {
        variant: "p",
    },
    trainingCardContent: {
        css: css`
            flex-grow: 1;
            padding: 8px 20px 15px 20px;
            display: flex;
            flex-direction: column;
        `,
    },
    featuredTitleSection: {
        css: css`
            margin-bottom: 26px !important;
        `,
    },
    featuredTrainingsWrapper: {
        css: css`
            display: grid;
            column-gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: repeat(1, 1fr);
                        `,
                        null,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                        `,
                        css`
                            grid-template-columns: repeat(3, 1fr);
                        `,
                    ],
                    "min",
                )}
        `,
    },
    featuredContainer: {
        css: css`
            background: ${getColor("secondary")};
            padding-top: 53px;
            padding-bottom: 60px;
            > .embla__container {
                position: relative;
                > div {
                    &:nth-of-type(2) {
                        > div {
                            > div {
                                > div {
                                    column-gap: 20px;
                                }
                            }
                        }
                    }
                    &:nth-of-type(1) {
                        position: absolute;
                        left: -22px;
                        z-index: 1;
                        margin-bottom: auto;
                        margin-top: auto;
                        > button {
                            border: none !important;
                        }
                    }
                    &:nth-of-type(3) {
                        position: absolute;
                        right: -22px;
                        z-index: 1;
                        margin-bottom: auto;
                        margin-top: auto;
                        > button {
                            border: none !important;
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 2rem;
                            padding-right: 2rem;
                        `,
                        null,
                        null,
                        css`
                            max-width: 100%;
                            padding-left: 80px;
                            padding-right: 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    featuredItem: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    featuredCardImg: {
        css: css`
            max-height: 180px;
            height: 180px;
            width: 100%;
            img {
                height: 100%;
                border-radius: 8px;
            }
        `,
    },
    featuredCardContent: {
        css: css`
            flex-grow: 1;
            padding: 12px 0 0 0;
            display: flex;
            flex-direction: column;
        `,
    },
    featuredTrainingDate: {
        color: "primary",
    },
    learnMoreLink: {
        typographyProps: {
            weight: 600,
        },
    },
    trainingsGridContainer: {
        gap: 21,
        css: css`
            max-width: 100% !important;
        `,
        offsetCss: css`
            width: 100% !important;
            margin: 0;
            margin-bottom: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 1rem;
                        `,
                        null,
                        null,
                        css`
                            max-width: 100%;
                            padding: 0 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    // Filter Section
    filtersGridItem: {
        width: [12, 12, 4, 4, 3],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0;
                            padding-right: 0;
                        `,
                        null,
                        css`
                            padding-top: 0;
                            padding-left: 0;
                            padding-right: 10.5px;
                        `,
                    ],
                    "min",
                )}
            [class^="AccordionSectionPanel"] {
                padding: 0px 20px 15px 20px;
            }
        `,
    },
    filterHeadingWrapper: {
        css: css`
            background: ${getColor("secondary")};
            border-radius: 6px;
            padding: 12px 20px;
            width: 100%;
            margin-bottom: 10px;
        `,
    },
    filterSectionHeading: {
        variant: "h6",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
    filterSectionsWrapper: {
        css: css`
            width: 100%;
        `,
    },
    // Filter Section Ends

    noResultGridItem: {
        width: [12, 12, 8, 8, 9],
        css: css`
            justify-content: center;
        `,
    },
};

const styles = newsListViewStyles;

interface OwnProps {
    trainings: any[];
    id: string;
}

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasShellContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const getDateWithMonthName = (dateObj: Date) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    return `${dateObj.getDate()} ${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
};

const OnlineManufacturerTrainingsListView: React.FC<Props> = ({
    trainings: receivedTrainings,
    id,
    theme,
    location,
    setFilters,
    typeFilters,
    selectedFilterNamesArr,
    filteredTrainings,
}) => {
    const [maxCarouselColumns, setMaxCarouselColumns] = React.useState<number>();
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const history = useHistory();
    const [initialLoad, setInintialLoad] = React.useState<boolean>(true);

    const queryParams: any = parseQueryString(location.search);

    const trainings = receivedTrainings.sort((a, b): any => {
        // Sort trainings by date older -> newer
        const secondDate: any = new Date(b?.fields?.trainingDate);
        const firstDate: any = new Date(a?.fields?.trainingDate);
        return firstDate - secondDate;
    });

    React.useEffect(() => {
        setFilters({
            trainings,
            queryParams,
            initialLoad,
        });
        setInintialLoad(false);
        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    React.useEffect(() => {
        if (!initialLoad) {
            setFilters({
                trainings,
                queryParams,
                initialLoad,
            });
        }
    }, [location.search]);

    React.useEffect(() => {
        const newMaxCarouselColumns = getMaxCarouselColumns();
        setMaxCarouselColumns(newMaxCarouselColumns);
    }, [maxCarouselColumns, windowResizeTime]);

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };

    const getMaxCarouselColumns = React.useCallback(() => {
        const maxNumberOfColumns = maxCarouselColumns || 3;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let noOfCarouselColumns: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            noOfCarouselColumns = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            noOfCarouselColumns = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            noOfCarouselColumns = 2;
        } else {
            noOfCarouselColumns = 3;
        }
        return noOfCarouselColumns;
    }, [maxCarouselColumns]);

    const updateQuery = (facet: FacetModel) => {
        const updatedFilterTypeQueryParamsArr = queryParams[facet.filterType]?.split(",") || [];
        const ind = updatedFilterTypeQueryParamsArr.findIndex(
            (item: string) => item.toLowerCase() === facet.name.toLowerCase(),
        );

        if (ind === -1) {
            updatedFilterTypeQueryParamsArr.push(facet.name.toLowerCase());
        } else {
            updatedFilterTypeQueryParamsArr.splice(ind, 1);
        }

        let updatedQueryParams = { ...queryParams };
        if (updatedFilterTypeQueryParamsArr.length === 0) {
            delete updatedQueryParams[facet.filterType];
        } else {
            updatedQueryParams = {
                ...queryParams,
                [facet.filterType]: updatedFilterTypeQueryParamsArr.join(","),
            };
        }

        const query = isEmpty(updatedQueryParams) ? "" : `?${new URLSearchParams(updatedQueryParams).toString()}`;
        history.push(`/Training/OnlineManufacturerTraining${query}`);
    };

    const handleFacetChange = (facet: FacetModel) => {
        updateQuery(facet);
    };

    const featuredCardContent = (training: any) => {
        return (
            <>
                <LazyImage {...styles.featuredCardImg} src={training?.fields?.trainingImage}></LazyImage>

                <StyledWrapper {...styles.featuredCardContent}>
                    {training?.fields?.trainingDate && (
                        <Typography {...styles.featuredTrainingDate}>
                            {getDateWithMonthName(new Date(training?.fields?.trainingDate))}
                        </Typography>
                    )}

                    <Typography {...styles.title}>{training?.fields?.title}</Typography>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Link
                            href={training?.fields?.registrationLink}
                            target={training?.fields?.openInNewWindow ? "_blank" : ""}
                            {...styles.learnMoreLink}
                        >
                            {training?.fields?.buttonText}
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
            </>
        );
    };

    const featuredCards = (featuredTrainings: any) => {
        const gap = maxCarouselColumns === 1 ? 0 : maxCarouselColumns === 2 ? 10 : 13.33;

        return featuredTrainings.map((training: { id: React.Key | undefined }) => (
            <FlexItem
                key={training?.id}
                {...styles.featuredItem}
                style={{
                    width: `calc(100% / ${maxCarouselColumns} - ${gap}px)`,
                    minWidth: `calc(100% / ${maxCarouselColumns} - ${gap}px)`,
                }}
            >
                {featuredCardContent(training)}
            </FlexItem>
        ));
    };

    if (trainings.length === 0) {
        return null;
    }

    const featuredTrainings = trainings.filter(training => training?.fields?.featured);

    return (
        <StyledWrapper {...styles.container}>
            {featuredTrainings.length > 0 && (
                <StyledWrapper {...styles.featuredContainer}>
                    <StyledWrapper {...styles.featuredTitleSection}>
                        <Zone contentId={id} zoneName="SectionTitle1" />
                    </StyledWrapper>

                    {featuredTrainings.length > 3 && (
                        <EmblaCarousel
                            options={{
                                align: "start",
                                slidesToScroll: maxCarouselColumns,
                                containScroll: "trimSnaps",
                            }}
                        >
                            {featuredCards(featuredTrainings)}
                        </EmblaCarousel>
                    )}
                    {featuredTrainings.length <= 3 && (
                        <StyledWrapper {...styles.featuredTrainingsWrapper}>
                            {featuredTrainings.map(training => {
                                return <StyledWrapper key={training.id}>{featuredCardContent(training)}</StyledWrapper>;
                            })}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
            <GridContainer {...styles.trainingsGridContainer}>
                <GridItem {...styles.trainingTitleSection}>
                    <Zone contentId={id} zoneName="SectionTitle2" />
                </GridItem>
                <GridItem {...styles.filtersGridItem}>
                    <StyledWrapper {...styles.filterHeadingWrapper}>
                        <Typography {...styles.filterSectionHeading}>Filter</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.filterSectionsWrapper}>
                        <TrainingFiltersAccordionSection
                            title="By Training Type"
                            facets={typeFilters}
                            onChangeFacet={handleFacetChange}
                            selectedFilterNamesArr={selectedFilterNamesArr}
                        />
                    </StyledWrapper>
                </GridItem>
                {filteredTrainings.length === 0 && (
                    <GridItem {...styles.noResultGridItem}>
                        <Typography variant="h2">No Training Found</Typography>
                    </GridItem>
                )}
                <GridItem {...styles.cardsGridItem}>
                    {filteredTrainings.map((training, i: any) => {
                        return (
                            <StyledWrapper {...styles.card} key={training.id}>
                                <LazyImage
                                    {...styles.trainingCardImg}
                                    src={training?.fields?.trainingImage}
                                ></LazyImage>
                                <StyledWrapper {...styles.trainingCardContent}>
                                    <Typography {...styles.trainingType}>{training?.fields?.trainingType}</Typography>
                                    <Typography {...styles.title}>{training?.fields?.title}</Typography>
                                    <Typography {...styles.description}>{training?.fields?.description}</Typography>
                                    <StyledWrapper {...styles.buttonWrapper}>
                                        <Link
                                            href={training?.fields?.registrationLink}
                                            target={training?.fields?.openInNewWindow ? "_blank" : ""}
                                            {...styles.learnMoreLink}
                                        >
                                            {training?.fields?.buttonText}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        );
                    })}
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withIsInShell(withTheme(OnlineManufacturerTrainingsListView)));
